// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioGroup_mantine_root__ycgR7"};